module.exports = __webpack_public_path__ + "img/19_49.09570958.png";